export default __webpack_public_path__ + "images/imagite-stone-1.svg";